import axios from "axios";
//axios.defaults.baseURL = process.env.REACT_APP_API_URL
const apiService = axios.create({
  baseURL: window.location.origin + "/wp-content/plugins/ppsposter-react/inc",
  // baseURL: window.location.origin,
});
const API = {
    async uploadImageStep2(urlImage, docSize,postionXY,imageWidth,imageHeight, price) {
        console.log("Details to be upload");
        console.log(`Files Image: ${urlImage.current}`)
        console.log(`Doc Width: ${docSize.current.width}`);
        console.log(`Doc Height: ${docSize.current.height}`);
        console.log(`Position X: ${postionXY.current.x}`);
        console.log(`Position Y: ${postionXY.current.y}`);
        console.log(`Image Width: ${imageWidth}`);
        console.log(`Image Height: ${imageHeight}`);
        console.log(`price: ${price}`);
        console.log("---------------------------------");
        // let formData = new FormData(); 
        // formData.append("photo", file)
        // formData.append("activity_type", '1');
        // formData.append("lead_id", '1'); 
        // formData.append("lat", '8.1040158');
        // formData.append("lng", '125.1248129');
        // formData.append("title", '125.1248129');
        // formData.append("notes", '125.1248129');
        // const result = axios
        //   .post(`http://api-application.test/api/activity`, formData, {
        //     headers: {
        //       "Content-Type": "multipart/form-data",
        //     },
        //   })
        //   .catch((err) => {
        //     console.log(err.response)
        //     return err.response;
        //   });
        // console.log(result);
      }, 

    async uploadImageStep1(file){
        let formData = new FormData(); 
        formData.append("photo", file) 
        const result = await axios
          .post('/wp-content/plugins/ppsposter-react/inc/poster-upload.php', formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .catch((err) => {
            console.log(err.response)
            return err.response;
          });
        console.log("-------------------API Response--------------");
        console.log(result);
        console.log("---------------------------------");
        return result;
    },

    async uploadImageTiffComp(file) {
      let formData = new FormData(); 
      formData.append("photo", file) 
      const result = await axios
        .post('/wp-content/plugins/ppsposter-react/inc/poster-upload.php', formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch((err) => {
          console.log(err.response)
          return err.response;
        });
      console.log("-------------------API Response--------------");
      console.log(result);
      console.log("---------------------------------");
      return result;      
    },

    async uploadDataUrl(file, f_name){
        let formData = new FormData(); 
        formData.append("data_url", file);
        formData.append("f_name", f_name);
        formData.append("ccode", "JSDEMLAE01");
        const result = await axios
          .post('/upload-data-url.php', formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .catch((err) => {
            console.log(err.response)
            return err.response;
          });
        console.log("-------------------API Response--------------");
        console.log(result);
        console.log("---------------------------------");
        return result;
    },

    async getDataUrl(f_name){
        let formData = new FormData(); 
        formData.append("f_name", f_name);
        formData.append("ccode", "JSDEMLAE01");
        const result = await axios
          .post('/get-data-url.php', formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .catch((err) => {
            console.log(err.response)
            return err.response;
          });
        console.log("-------------------API Response--------------");
        //console.log(result);
        console.log("---------------------------------");
        return result;
    },

    async generatePDF(imageUrl, docHeight, docWidth, imgHeight, imgWidth, imgX, imgY, time_s, file_ext, file_exif){
      let formData = new FormData(); 
      formData.append("img_exif", file_exif);
      formData.append("image_url", imageUrl);
      formData.append("doc_height", docHeight);
      formData.append("doc_width", docWidth);
      formData.append("img_height", imgHeight);
      formData.append("img_width", imgWidth);
      formData.append("img_x", imgX);
      formData.append("img_y", imgY);
      formData.append("time_s", time_s);
      formData.append("file_ext", file_ext);
      formData.append("ccode", "JSDEMLAE01");
      const result = await axios
        .post(`/wp-content/plugins/ppsposter-react/inc/poster-pdf.php`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch((err) => {
          // alert('Something went wrong with your image upload. Please refresh and try again, or try our Advanced Order at https://www.ppsposter.com/advanced-order');
          return err.response;
        });
    
      console.log("-------------------API Response--------------");
      console.log(result);
      console.log("---------------------------------");
      // if(result.status !== 200){
      //   return result;
      // }

      return result;
  },

  async generatePDFProof(imageUrl, docHeight, docWidth, imgHeight, imgWidth, imgX, imgY, time_s, file_ext){
    let formData = new FormData(); 
    formData.append("image_url", imageUrl);
    formData.append("doc_height", docHeight);
    formData.append("doc_width", docWidth);
    formData.append("img_height", imgHeight);
    formData.append("img_width", imgWidth);
    formData.append("img_x", imgX);
    formData.append("img_y", imgY);
    formData.append("time_s", time_s);
    formData.append("file_ext", file_ext);
    formData.append("ccode", "JSDEMLAE01");
    const result = await axios
      .post(`/wp-content/plugins/ppsposter-react/inc/poster-pdf-proof.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .catch((err) => {
        console.log('err: ', err);
        console.log('err.stack: ', err.stack);
        console.log('err.response: ', err.response);
        return err.response;
      });
    console.log("-------------------API Response--------------");
    console.log(result);
    console.log("---------------------------------");
    return result;
  },

  async generatePDFOnlyProof(imageUrl, docHeight, docWidth, imgHeight, imgWidth, imgX, imgY, time_s, file_ext){
    let formData = new FormData(); 
    formData.append("image_url", imageUrl);
    formData.append("doc_height", docHeight);
    formData.append("doc_width", docWidth);
    formData.append("img_height", imgHeight);
    formData.append("img_width", imgWidth);
    formData.append("img_x", imgX);
    formData.append("img_y", imgY);
    formData.append("time_s", time_s);
    formData.append("file_ext", file_ext);
    formData.append("ccode", "JSDEMLAE01");
    const result = await axios
      .post(`/wp-content/plugins/ppsposter-react/inc/poster-pdf-only-proof.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .catch((err) => {
        console.log('err: ', err);
        console.log('err.stack: ', err.stack);
        console.log('err.response: ', err.response);
        return err.response;
      });
    console.log("-------------------API Response--------------");
    console.log(result);
    console.log("---------------------------------");
    return result;
  },
 
};

export const uploadFile = (file, file_type, timestmp, fname='', onUploadProgress) => {
  const formData = new FormData();
  console.log('prod upload file..');
  formData.append('f_name', fname); 
  formData.append('photo', file); 
  formData.append('file_type', file_type);
  formData.append('timestmp', timestmp);
  formData.append('ccode', 'JSDEMLAE01');
  return apiService.post('/poster-upload.php', formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  })
  .then(response => {
    console.log("-------------------API Response--------------");
    console.log(response);
    console.log("---------------------------------");
    return response;
  })
  .catch(err => {
    console.log('Error: ', err);
    console.log('Error Stack: ', err.stack);
    console.log('Error Response: ', err.response);
    return err.response;
  });
};

export const uploadFileProduct = (file, file_type, timestmp, onUploadProgress) => {
  const formData = new FormData();
  console.log('prod upload file..');
  formData.append('photo', file); 
  formData.append('file_type', file_type);
  formData.append('timestmp', timestmp);
  formData.append('ccode', 'JSDEMLAE01');
  return apiService.post('/upload-product.php', formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
};

export const uploadFileFile = (file, file_type, timestmp, onUploadProgress) => {
  const formData = new FormData();
  console.log('prod upload file.. uploadFileFile');
  console.log(file);
  console.log(JSON.stringify(file));
  formData.append('photo', JSON.stringify(file)); 
  formData.append('file_type', file_type);
  formData.append('timestmp', timestmp);
  formData.append('ccode', 'JSDEMLAE01');
  return apiService.post('/upload-file-only.php', formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
};

export default API;



